module.exports = __webpack_public_path__ + "img/6.607d13a2.jpg";